module.exports = __webpack_public_path__ + "img/refrigerador.4307a15c.svg";